/**
 * @desc 更新物流追踪信息
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(body: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/transportMaster/importTrackExcel`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
